import React, { Fragment, useEffect, useState } from "react";
import { Popup as SemanticPopup, Button, ButtonProps, Divider, Form, Icon, SemanticCOLORS, TextAreaProps, Label } from "semantic-ui-react";
import { SemanticICONS } from "semantic-ui-react/dist/commonjs/generic";
import { TMapAuditingCheck } from "../IMapAuditing";
import ImageUpload from "../../../auditoinnit/components/form/ImageUpload";


interface MapAuditingCheckForm {
    initialFormData?: Partial<TMapAuditingCheck>;
    onSubmit?: (formData: TMapAuditingCheck) => void;
    onCancel?: () => void;
    onRemove?: () => void;
};

export const MapAuditingCheckForm: React.FC<MapAuditingCheckForm> = ({
    initialFormData = {},
    onSubmit,
    onCancel,
    onRemove
}) => {

    const [formData, setFormData] = useState<Partial<TMapAuditingCheck>>(initialFormData);

    const [missingRequiredProperties, setMissingRequiredProperties] = useState<boolean>(false);

    useEffect(() => {
        if (formData && missingRequiredProperties) {
            setMissingRequiredProperties(false)
        }
    }, [formData]); // eslint-disable-line

    const submit = () => {
        if (formData.status === "korjattavaa" && (!formData.description && !formData.images?.length)) {
            return setMissingRequiredProperties(true)
        }
        if (onSubmit) {
            onSubmit(formData as TMapAuditingCheck);
        };
    };

    const updateFormData = <T extends keyof typeof formData>(key: T, value: typeof formData[T]) => {
        setFormData((prev) => ({ ...prev, [key]: value }));
    };

    const updateStatus: ButtonProps["onClick"] = (_1, { status, active }) => {
        updateFormData("status", active ? undefined : status);
    };


    const updateDescription: TextAreaProps["onChange"] = (_1, { value }) => {
        updateFormData("description", value as string);
    };


    const renderCheckButton = (status: TMapAuditingCheck["status"], text: string, color?: SemanticCOLORS, icon?: SemanticICONS) => (
        <Button
            type="button"
            status={status}
            active={status === formData.status}
            color={status === formData.status ? color : undefined}
            onClick={updateStatus}
            icon={icon ? < Icon name={icon} color={color} inverted={status === formData.status} /> : undefined}
            content={text}
            size="tiny"
        />
    );

    return (
        <Form className="MapAuditingCheckForm" as="div" size="tiny">
            <Form.Field>
                <Button.Group size="tiny">
                    {renderCheckButton("kunnossa", "Kunnossa", "green", "check")}
                    {renderCheckButton("korjattavaa", "Korjattavaa", "red", "times")}
                </Button.Group>
            </Form.Field>

            <Form.TextArea
                error={missingRequiredProperties ? "Huomiolla tulee olla kuvaus tai valokuva" : undefined}
                label="Huomiot"
                value={formData.description}
                onChange={updateDescription}
            />


            <Form.Field >
                <ImageUpload
                    value={formData.images?.map((guid) => ({ id: guid, name: "" })) as any}
                    onChange={(value) => { updateFormData("images", Array.isArray(value) ? value.map((img) => img.id) : undefined); }}
                    isMulti
                    //@ts-ignore
                    InputElement={({ children }) => (
                        <Button
                            type="button"
                            icon="camera"
                            size="tiny"
                            content={<Fragment> {"Lisää kuva"} {children} </Fragment>}
                        />
                    )}

                />
            </Form.Field>


            <Divider />
            <Button type="button" content="Tallenna" onClick={submit} size="tiny" primary />
            <Button type="button" content="Peruuta" onClick={onCancel} size="tiny" />
            {onRemove && (
                <Button type="button" content="Poista" size="tiny" onClick={onRemove} />
            )}
        </Form>
    )
};
